export default "__VITE_ASSET__DRSruEtH__"